import { render } from "./HomePage.vue?vue&type=template&id=00d694d2&ts=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__